(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('posIncomeReportController', posIncomeReportController);

  /** @ngInject */
  function posIncomeReportController(
    $scope,
    $translate,
    reportExportUtil,
    exportToCsv,
    PosIncomeReportViewModel,
    dispatcher,
    ActionTypesEnum
  ) {
    var vm = this;

    vm.report = new PosIncomeReportViewModel();
    vm.exportToCsv = exportCsv;

    init();

    function init() {
      $scope.$on('$destroy', destroy);
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_LOADER
      });
    }

    function destroy() {
      vm.report.destroy();
    }

    function exportCsv() {
      var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
        $translate.instant('DAYS'),
        vm.report.chart.data,
        reportExportUtil.ValueFormattersEnum.DATE,
        reportExportUtil.ValueFormattersEnum.NUMBER
      );

      exportToCsv.export(
        jsonArrayForExport,
        $translate.instant('POS_INCOME'),
        true
      );
    }
  }
})();
